import React, { FC, memo } from "react";
// libs
import isEqual from "lodash/isEqual";
// components
import ReactRatingComponent from "src/components/ui/Rating";
// utils
import { transformRateCountReviews, calcAvgRating, calcReviewsCount } from "src/utils/reviews";
import { getClinicImagePathSmall } from "src/utils/clinics";
// types
import { IClinicCardProps } from "./clinic.types";
// theme
import {
  MainRow,
  Row,
  Column,
  Wrapper,
  NextImageWrapper,
  ClinicTitle,
  ClinicAddress,
  RatingCountText,
  RateText,
  SpeciesList,
  RecommendedButton,
  SpeciesItem,
} from "./clinic.styles";

const ClinicCard: FC<IClinicCardProps> = ({
  name,
  logo_url,
  address,
  rating,
  services = [],
  fromPetsapp,
}) => {
  const reviewsCount = calcReviewsCount(rating);
  const avgRating = Number(calcAvgRating(rating));

  return (
    <Wrapper>
      <MainRow>
        <NextImageWrapper bg={getClinicImagePathSmall(logo_url)} isCustomBg={!!logo_url} />
        <Column margin="0 0 0 15px">
          <ClinicTitle>{name}</ClinicTitle>
          <Row wrap="wrap">
            <ClinicAddress>{address}</ClinicAddress>
            {!!reviewsCount && (
              <Row wrap="wrap">
                <Row>
                  <ReactRatingComponent readonly initialRating={Math.round(+avgRating)} />
                  <RatingCountText>{avgRating}</RatingCountText>
                </Row>
                <RateText margin="0 0 0 10px">
                  ({transformRateCountReviews(reviewsCount)} reviews)
                </RateText>
              </Row>
            )}
          </Row>
          <SpeciesList>
            {fromPetsapp && (
              <RecommendedButton>
                Recommended
              </RecommendedButton>
            )}
            {(services as string[]).slice(0, 4).map((item: any) => (
              <SpeciesItem key={item}>{item}</SpeciesItem>
            ))}
          </SpeciesList>
        </Column>
      </MainRow>

      {/* <SpeciesList>
        {recomended && <SpeciesButton>Recommended</SpeciesButton>}
        {services.map((item: string, idx: number) => (
          <SpeciesItem key={item.id} offsetFirst={!!recomended}>
            {item.name}
          </SpeciesItem>
        ))}
      </SpeciesList> */}
    </Wrapper>
  );
};

export default memo(ClinicCard, isEqual);
